'use strict';
import GoogleMap from 'google-map-react-cn';
import React from 'react';
import {BounceLoader} from 'react-spinners';
import Location from './LocationComponent';
import Navigator from './NavigatorComponent';
import MapMarker from './MapMarkerComponent';
import MediaStore from 'stores/MediaStore';
import MediaActions from 'actions/MediaActions';
import CommentActions from 'actions/CommentActions';
import Carousel from 'nuka-carousel';
import {Link,browserHistory} from 'react-router';
import API from 'sources/API';

import 'styles/MediaDetail.scss';
require('styles/SweetLoading.scss');

const defaultCenter = [59.938043, 30.337157];
function createMapOptions(maps) {
  return {
    zoomControlOptions: {
      position: maps.ControlPosition.RIGHT_CENTER,
      style: maps.ZoomControlStyle.SMALL
    },
    mapTypeControlOptions: {
      position: maps.ControlPosition.TOP_RIGHT
    },
    mapTypeControl: true
  };
}

let that;
class MediaDetailComponent extends React.Component {
  constructor(props) {
    super(props);
    let mediaStore = MediaStore.getState();
    this.state = {
      center: defaultCenter,
      zoom: 14,
      media_id: this.props.params.id,
      commentText: '',
      media: mediaStore.media,
      product: null,
      touchPageY: 0,
      picRevealShow: false,
      picRevealSrc: '',
      mapRevealShow: false,
      alertRevealShow: false,
      payRevealShow: false,
      commentRevealShow: false,
      isAuthor: false,
      has_hidden: false,
      loading: true,
      recommendMedias: [],
      recommendArticles: []
    };
    this.mixins = [Carousel.ControllerMixin];
    this.onMediaChange = this.onMediaChange.bind(this);
    this.postComment = this.postComment.bind(this);
    this.deleteMedia = this.deleteMedia.bind(this);
    this.onCommentTextChange = this.onCommentTextChange.bind(this);
    this.onCommentTextClick = this.onCommentTextClick.bind(this);
    this.imgDragging = this.imgDragging.bind(this);
    this.mediaPay = this.mediaPay.bind(this);
    this.showPic = this.showPic.bind(this);
    this.toggleReveal = this.toggleReveal.bind(this);
    this.openGoogleMap = this.openGoogleMap.bind(this);
    this.wechatLogin = this.wechatLogin.bind(this);
  }
  componentDidMount() {
    if(API.isWechat){
      fetch(API.getWechatConfig).then(res=>res.json()).then(json=>{
        if(json.appId) {
            window.wx.config(json);
        }
      })
    }

    window.scrollTo(0, 0);

    let media_id = this.props.params.id;
    MediaActions.fetchMedia(media_id);
    MediaStore.listen(this.onMediaChange);

    that = this;
    fetch(API.getRecommendMediaList.replace(':id',media_id)).then(res=>res.json()).then(json => {
      if(json.status == 0){
        that.setState({
          recommendMedias: json.result.medias,
          recommendArticles: json.result.album
        })
      }
    })

    window._hmt.push(['_trackPageview', this.props.location.pathname]);
  }
  componentWillUnmount() {
    MediaStore.unlisten(this.onMediaChange);
    MediaActions.refreshMedia();
  }
  onMediaChange(media) {
    this.setState({
      media: media.media,
      product: media.media.product,
      isAuthor: media.media.isAuthor,
      has_hidden: media.media.has_hidden,
      center: media.media.formatted_address?[media.media.lat,media.media.lng]:defaultCenter,
      loading: (media.media._id&&media.media._id===this.props.params.id)?false:true
    });
    if(this.state.media.images) {
      let mediaName = this.state.media.format_desc;
      let sharePic = this.state.media.images.small[0];
      let media_id = this.state.media_id;
      let address = this.state.media.name || this.state.media.formatted_address || '';
      let callback = () => {
        if(!address && API.accessToken){
          let params = {
            method: 'POST',
            headers: API.urlHeader,
            body: `media_id=${media_id}`
          };
          fetch(API.postMediaWxShare, params)
          .then(res=>res.json())
          .then(json=>{
            if(json.status == '0'){
              browserHistory.push('/result/pay'); // 分享即免费
            }
          });
        }
      }
      window.wx.onMenuShareTimeline({
        title: `${mediaName}-小地球旅行`,
        link:  location.href,
        imgUrl: encodeURI(sharePic),
        success: function () {
          callback()
        }
      });
      window.wx.onMenuShareAppMessage({
        title: `${mediaName}-小地球旅行`,
        desc: `分享小地球——${mediaName}。加入小地球旅行，发现有趣的地方`,
        link: location.href,
        imgUrl: encodeURI(sharePic),
        type: 'link',
        success: function () {
          callback()   
        }
      });
      let title = this.state.media.formatted_address?`${this.state.media.name}-${this.state.media.city.name}小众旅行目的地-${this.state.media.formatted_address}`:this.state.media.title;
      let desc = `${this.state.media.format_desc.substring(0,150)}...`;
      let keywords = `${this.state.media.continent.name} ${this.state.media.country.name}小众旅行目的地  ${this.state.media.state.name}小众旅行目的地  ${this.state.media.city.name}小众旅行目的地 
      ${this.state.media.name?this.state.media.name:''} ${this.state.media.formatted_address?this.state.media.formatted_address:''}`;
      window.changeMetaForSEO(title,desc,keywords);
    }
  }
  deleteMedia(){
    MediaActions.deleteMedia(this.state.media_id);
    MediaActions.refreshMediaList();
  }
  onCommentTextChange(event) {
    let text = event.target.value;
    this.setState({commentText: text});
  }
  onCommentTextClick(event) {
    let check = API.checkToken;
  }
  postComment() {
    window.ga('send', {
      hitType: 'event',
      eventCategory: 'media',
      eventAction: 'comment',
    });
    CommentActions.postComment({
      media_id: this.state.media_id,
      content: this.state.commentText,
      comment_id: null // 回复盖楼需要
    });
  }
  componentDidUpdate(prevProps, prevState) {
    let banner = document.querySelector('.author.media-object');
    let sliderList = document.querySelector('.slider-list');
    if(banner && sliderList) {
      sliderList.style.height = banner.clientWidth + 'px';
    }
  }
  imgDragging(e) {
    if(e.nativeEvent.type === 'touchstart') {
      this.setState({touchPageY: e.touches[0].pageY});
    } else if(e.nativeEvent.type === 'touchend') {
      let offset = e.changedTouches[0].pageY - this.state.touchPageY;
      window.scrollTo(0, window.scrollY - offset);
    }
  }
  showPic(e) {
    if(API.isWechat){
      wx.previewImage({
        current: e.target.getAttribute('origin'), // 当前显示图片的http链接
        urls: this.state.media.images?this.state.media.images.origin:[]// 需要预览的图片http链接列表
      });
    }else{
      this.setState({
        picRevealShow: true,
        picRevealSrc: e.target.getAttribute('origin')
      });
    }
  }
  toggleReveal(type) {
    let key = `${type}RevealShow`;
    let newState = {};
    if(this.state[key]) {
      newState[key] = false;
    } else {
      newState[key] = true;
    }
    this.setState(newState);
  }
  openGoogleMap(event) {
    browserHistory.push('/map');
  }
  wechatLogin() {
    if(API.isWechat) {
      let check = API.checkToken;
    }
  }
  mediaPay() {
    if(this.state.loading) return
    let check = API.checkToken;
    if(check) {
      this.setState({payRevealShow: false, commentRevealShow: false});
      if(!API.isWechat) {
        this.toggleReveal('alert');
        return;
      }
      this.setState({loading: true})
      let params = {
        method: 'POST',
        headers: API.urlHeader,
        body: `accessToken=${API.accessToken}`
      };
      let media_id = this.state.media_id;
      let self = this
      fetch(API.postMediaPay.replace(':id', this.state.media_id), params)
        .then(res=>res.json())
        .then(json=>{
          self.setState({loading: false})
          function onBridgeReady(){
            window.WeixinJSBridge.invoke('getBrandWCPayRequest', json.options, function(res){
              MediaActions.fetchMedia(media_id);
              if(res.err_msg === "get_brand_wcpay_request：ok" || res.err_msg.indexOf("ok") !== -1 ) {
                browserHistory.push('/result/pay');
              }
            });
          }
          if (typeof WeixinJSBridge === "undefined"){
            if( document.addEventListener ){
              document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
            } else if (document.attachEvent){
              document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
              document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
            }
          } else {
            onBridgeReady();
          }
        });
    }
  }
  render() {
    let price, freeInfo, comments, seeAllComments;
    if(this.state.media.comments) {
      comments = this.state.media.comments.map((comment)=>{
        return (
          <div className="comment bg-white" key={comment._id}>
            <div className="comment-meta clearfix">
              <Link to={`/user/${comment.author._id}`}>
                <img className="comment-avatar float-left contain" width="30" height="30" src={comment.author.avatar} />
              </Link>
              <h4 className="float-left">
                <Link to={`/user/${comment.author._id}`} className="text-black">{comment.author.name}</Link>
              </h4>
              <span className="fz-12 text-gray float-right">{new Date(comment.create_date).toLocaleDateString()} {new Date(comment.create_date).toLocaleTimeString()}</span>
            </div>
            <div className="comment-content">{comment.content}</div>
          </div>
        );
      });
    }
    if(this.state.media.free || this.state.media.formatted_address || this.state.media.comment_amount <= 2) {
      seeAllComments = <div className="columns">
        <Link to={`/media/${this.state.media_id}/comments`} className="more-comments fz-12 text-center text-gray">
          查看全部 {this.state.media.comment_amount} 条评论
          <i className="fa fa-angle-right" aria-hidden="true"></i>
        </Link>
      </div>
    } else {
      seeAllComments = <div className="columns">
        <span className="more-comments fz-12 text-center text-gray" onClick={this.toggleReveal.bind(this, 'comment')}>
          查看全部 {this.state.media.comment_amount} 条评论
          <i className="fa fa-angle-right" aria-hidden="true"></i>
        </span>
      </div>
    }
    if(this.state.media.name || this.state.media.formatted_address) {
      price = (
        <Link to='/map'>
          <div className="price shown">{this.state.media.name || this.state.media.formatted_address}</div>
        </Link>
      );
    } else {
      price = <div className="price" onClick={this.mediaPay}>{this.state.media.price} 元</div>
      freeInfo = <div className="fz-12 text-gray columns" style={{backgroundColor: 'white',padding:"5px 15px",marginTop:"-10px"}}>微信{API.accessToken?'':<a href="javascript:void(0)" onClick={this.wechatLogin}>登陆</a>}{API.accessToken?'支付':',付费'}查看在哪儿? <a style={{color:"#333"}}>(分享或PC端查看免费哟)</a></div>
    }
    let picReveal, mapReveal, alertReveal;
    if(this.state.picRevealShow) {
      picReveal = (
        <div className="reveal-overlay">
          <div className="full reveal img-center" style={{backgroundColor:'#333'}}>
            <button className="close-button" aria-label="Close modal" type="button" onClick={this.toggleReveal.bind(this ,'pic')}>
              <span aria-hidden="true">&times;</span>
            </button>
            <img src={this.state.picRevealSrc} width='100%' />
          </div>
        </div>
      );
    }
    if(this.state.alertRevealShow) {
      alertReveal = (
        <div className="reveal-overlay">
          <div className="reveal">
            <button className="close-button" aria-label="Close modal" type="button" onClick={this.toggleReveal.bind(this ,'alert')}>
              <span aria-hidden="true">&times;</span>
            </button>
            <p className="mt-30 text-center">请在微信内完成支付。</p>
          </div>
        </div>
      );
    }
    // if(this.state.mapRevealShow && this.state.media.title) {
    //   mapReveal = (
    //     <div className="reveal-overlay">
    //       <div className="full reveal" style={{backgroundColor:'#333'}}>
    //         <button className="close-button" aria-label="Close modal" type="button" onClick={this.toggleReveal.bind(this ,'map')}>
    //           <span aria-hidden="true">&times;</span>
    //         </button>
    //         <iframe width="100%" height="100%" frameBorder="0" style={{border:0}} src={`https://www.google.com/maps/embed/v1/place?q=${this.state.media.title}&key=AIzaSyD_ZTZFu4nWc12-C-mJWvqNP61AP6ZUU8Y`} allowFullScreen></iframe>
    //       </div>
    //     </div>
    //   );
    // }
    
    let carousel;
    if(this.state.media.images && this.state.media.images.big.length > 1) {
      carousel = (
        <Carousel className="orbit-container" autoplay={true} wrapAround={true} autoplayInterval={3000} >
          {(this.state.media.images && this.state.media.images.big.length) ? this.state.media.images.big.map((img, ind) => {
            return (
              <img key={ind} onClick={this.showPic} className="contain banner" onTouchStart={this.imgDragging}  onTouchEnd={this.imgDragging}
              origin={this.state.media.images.origin.length?this.state.media.images.origin[ind]:img} src={img} />
            );
          }) : ''}
        </Carousel>
      );
    } else {
      carousel = (
        <img onClick={this.showPic} className="contain banner" origin={(this.state.media.images && this.state.media.images.origin.length)?
          this.state.media.images.origin[0]:((this.state.media.images && this.state.media.images.big.length)?
            this.state.media.images.big[0]: '')}
        src={(this.state.media.images && this.state.media.images.big.length)?this.state.media.images.big[0]: ''} />
      );
    }
    
    let map;
    if(this.state.media.formatted_address) {
      map =(
        <a href={this.state.media.formatted_address ? `http://google.cn/maps?q=${this.state.media.formatted_address}`: ''}>
          <i className="fa fa-map-o" aria-hidden="true" onClick={this.toggleReveal.bind(this ,'map')}></i>
        </a>
      );
    } else {
      map = <i className="fa fa-map-o" aria-hidden="true" onClick={this.toggleReveal.bind(this ,'pay')}></i>
    }

    let payReveal;
    if(this.state.payRevealShow) {
      payReveal = (
        <div className="reveal-overlay">
          <div className="reveal">
            <button className="close-button" aria-label="Close modal" type="button" onClick={this.toggleReveal.bind(this ,'pay')}>
              <span aria-hidden="true">&times;</span>
            </button>
            <p className="mt-30 text-center">需付费后查看详细地址。</p>
            <button className="button float-left mb-0" style={{backgroundColor:'transparent', color: '#333'}}
              onClick={this.toggleReveal.bind(this, 'pay')}>取消</button>
            <button className="button float-right mb-0" onClick={this.mediaPay}>去支付</button>
          </div>
        </div>
      );
    }

    let googleMap;
    if(this.state.media.formatted_address){
      googleMap = (
        // <div className="map" onClick={this.openGoogleMap}>
        <div className="map">
          <GoogleMap
            bootstrapURLKeys={{key: API.getMapAPIKey}}
            center={this.state.center}
            zoom={this.state.zoom}
            options={createMapOptions}>
            <MapMarker lat={this.state.center[0]} lng={this.state.center[1]} text={'D'}/>
          </GoogleMap>
        </div>
      );
    }

    let commentReveal;
    if(this.state.commentRevealShow) {
      commentReveal = (
        <div className="reveal-overlay">
          <div className="reveal">
            <button className="close-button" aria-label="Close modal" type="button" onClick={this.toggleReveal.bind(this ,'pay')}>
              <span aria-hidden="true">&times;</span>
            </button>
            <p className="mt-30 text-center">隐藏地点无法查看评论，需付费查看。</p>
            <button className="button float-left mb-0" style={{backgroundColor:'transparent', color: '#333'}} 
              onClick={this.toggleReveal.bind(this, 'comment')}>取消</button>
            <button className="button float-right mb-0" onClick={this.mediaPay}>去支付</button>
          </div>
        </div>
      );
    }

    let deleteReveal;
    if(this.state.isAuthor){
      deleteReveal = (
        <div className="columns">
          <div className="">
            <button className="button expanded delete mb-0" onClick={this.deleteMedia}>删除</button>
          </div>
        </div>
      );
    }

    let hiddenDescReveal,hiddenUrlReveal,hiddenAlertReveal; 
    let createHiddenMarkup = () => {
      return {__html: this.state.media.hidden_desc};
    }

    if(this.state.media.formatted_address){
      if(this.state.media.hidden_desc){
        hiddenDescReveal = (
          <div className="columns hidden-info">
            <div className="bg-white hidden-info-desc">
              <p className="fz-12 text-highlighted">隐藏信息:</p>
              <pre className="hidden-desc fz-14" dangerouslySetInnerHTML={createHiddenMarkup()}>
              </pre>
            </div>
          </div>
        );
      }
      if(this.state.media.hidden_url){
        let hidden_url = this.state.media.hidden_url;
        hidden_url = hidden_url.indexOf('http')<0?`http://${hidden_url}`:hidden_url;
        hiddenUrlReveal = (
          <div className="columns hidden-info">
            <div className="bg-white hidden-info-url clearfix">
              <div className="hidden-url float-left fz-12 text-highlighted"> 隐藏链接：
                <a href={hidden_url}>秘密链接</a>
              </div>
            </div>
          </div>
        );
      }
    }else{
      // hiddenAlertReveal = (
      //   <div className="columns hidden-info">
      //     <div className="bg-white text-center text-gray fz-12 hidden-info-notification">
      //       为宇航员的探索支付鼓励金, 查看准确地理坐标或隐藏信息 (登陆并微信分享可<span style={{color:"#333"}}>免费</span>查看)
      //     </div>
      //   </div>
      // );
    }

    let productReveal;
    if(this.state.product){
      productReveal = (
        <div className="columns">
          <div className="bg-white product-info">
            <p className="fz-12 text-highlighted">行程推荐:</p>
            <a href={this.state.product.url?this.state.product.url:`/route/${this.state.product._id}`}>
              <div className="product">
                <div className="cover">
                  <img src={this.state.product.cover.big.replace('!li750','')} />
                  <span className="price">¥{this.state.product.price}</span>
                </div>
                <div className="title fz-14 mt-15">
                  {this.state.product.title}
                </div>
              </div>
            </a>
         </div>
        </div>
      );
    }

    let mediasRecommendReveal,albumsRecommendReveal;
    if(this.state.recommendMedias && this.state.recommendMedias.length){
      let recommendMedias = this.state.recommendMedias;
      let length = recommendMedias.length;
      if(length == 3){
        recommendMedias = recommendMedias.splice(0,2);
      }
      length = recommendMedias.length;
      if(length == 1){
        let media = recommendMedias[0];
        mediasRecommendReveal = (
          <div className="columns">
            <div className="bg-white product-info">
              <p className="fz-12 text-highlighted">奇趣推荐:</p>
              <a href={`/media/${media._id}`}>
                <div className="product">
                  <div className="cover">
                    <img src={media.images.big[0].replace('!li750','')} />
                  </div>
                  <div className="title fz-14 mt-15">
                    {media.desc}
                  </div>
                </div>
              </a>
           </div>
          </div>
        );
      }else{
        mediasRecommendReveal = (
          <div className="columns">
            <div className="bg-white recommend">
              <p className="fz-12 text-highlighted">奇趣推荐:</p>
              {recommendMedias.map(media => (
                <a href={`/media/${media._id}`} className="item" key={media._id}>
                  <div className="cover">
                    <img src={media.images.big[0]} />
                  </div>
                  <div className="title">
                    {media.desc}
                  </div>
                </a>
              ))}
              <div className="clear"></div>
            </div>
          </div>
        );
      }
    }

    if(this.state.recommendArticles && this.state.recommendArticles.length){
      if(this.state.recommendArticles.length % 2 == 0){
        albumsRecommendReveal = (
          <div className="columns recommend">
            <div className="bg-white recommend">
              <p className="fz-12 text-highlighted">文章推荐:</p>
              {this.state.recommendArticles.map(album => (
                <a href={`/article/${album._id}`} className="item" key={album._id}>
                  <div className="cover">
                    <img src={album.medias[0].images.big[0]} />
                  </div>
                  <div className="title">
                    {album.name}
                  </div>
                </a>
              ))}
              <div className="clear"></div>
            </div>
          </div>
        );
      }else{
        let album = this.state.recommendArticles[0];
        albumsRecommendReveal = (
          <div className="columns">
            <div className="bg-white product-info">
              <p className="fz-12 text-highlighted">文章推荐:</p>
              <a href={`/article/${album._id}`}>
                <div className="product">
                  <div className="cover">
                    <img src={album.medias[0].images.big[0].replace('!li750','')} />
                  </div>
                  <div className="title fz-14 mt-15">
                    {album.name}
                  </div>
                </div>
              </a>
           </div>
          </div>
        );
      }
    }

    let createMarkup = () =>  {
      return {__html: this.state.media.format_desc};
    }
    return (
      <div className="mediadetail-component">
        <div className='sweet-loading'>
          <BounceLoader
            sizeUnit={"px"}
            size={50}
            color={'#333'}
            loading={this.state.loading}
          />
        </div>
        {picReveal}
        {mapReveal}
        {alertReveal}
        {payReveal}
        {commentReveal}
        <Location showList={false} isExplore={false}
          continent={this.state.media.continent}
          country={this.state.media.country}
          state={this.state.media.state}
          city={this.state.media.city}
        />
        <div className="row">
          <div className="media-detail columns">
            <div className="bg-white media-content">
              <div className="orbit" role="region" data-orbit>
                {carousel}
              </div>
              <Link to={`/user/${this.state.media.author ? this.state.media.author._id : ''}`} className="author media-object">
                <div className="media-object-section">
                  {this.state.media.author?<img className="avatar contain" width="45" height="45" src={this.state.media.author.avatar} />:''}
                </div>
                <div className="author-meta media-object-section">
                  <h5 className="text-black mb-0">{this.state.media.author ? this.state.media.author.name : ''}</h5>
                  <div className="text-gray fz-12 summary">{this.state.media.author && this.state.media.author.summary ? this.state.media.author.summary : <i>这里空空如也～～</i>}</div>
                </div>
              </Link>
              <div className="view-count">阅读量: {this.state.media.view}</div>
              <pre className="fz-14 mb-15 mt-10 format-desc" dangerouslySetInnerHTML={createMarkup()}></pre>
              <div className="media-meta clearfix">
                <div className="float-left fz-12 text-gray" dangerouslySetInnerHTML={{__html: this.state.media.format_from ? `来源：${this.state.media.format_from}` : ''}} ></div>
                <Link to={`/media/${this.state.media_id}/collect`} className="float-right button mb-0 mt-10">收藏 {this.state.media.save_user_amount}</Link>
              </div>
            </div>
          </div>
          <div className="columns">
            <div className="bg-white small-10 columns text-center">
              {price}
            </div>
            <div className="bg-white small-2 columns">
              {map}
            </div>
            {freeInfo}
          </div>
          {API.isMobile?<div className="columns">{googleMap}</div>:null}
          {hiddenDescReveal}
          {hiddenUrlReveal}
          {/* {hiddenAlertReveal} */}
          {mediasRecommendReveal}
          {albumsRecommendReveal}
          {productReveal}
          <div className="columns">
            {comments}
          </div>
          {seeAllComments}
          <div className="columns">
            <div className="">
              <textarea placeholder="说点什么吧" onClick={this.onCommentTextClick} 
                onChange={this.onCommentTextChange}></textarea>
              <button className="button expanded mb-10 mt-15" onClick={this.postComment}>评论</button>
            </div>
          </div>
          {deleteReveal}
        </div>
        <Navigator action='left' />
      </div>
    );
  }
}

MediaDetailComponent.displayName = 'MediaDetailComponent';
export default MediaDetailComponent;



// WEBPACK FOOTER //
// ./src/components/MediaDetailComponent.js